/*
 * @Author: AllezLRC 13636411941@163.com
 * @Date: 2025-03-24 10:15:20
 * @LastEditors: AllezLRC 13636411941@163.com
 * @LastEditTime: 2025-03-27 18:13:49
 * @FilePath: /wemeet-admin-new/src/api/recruitment/talentBank.js
 * @Description:
 * Copyright (c) 2025 by WeMeet, All Rights Reserved.
 */
import request from '@/utils/request'

// 查询人才库
export function getTalentList(params) {
  return request({
    url: '/user/admin/enterprise/job/queryList',
    method: 'GET',
    params,
  })
}

// 更新人才状态
export function updateTalentStatus(data) {
  return request({
    url: '/user/admin/enterprise/job/updateJobStatus',
    method: 'POST',
    data,
  })
}

// 查询人才库详情
export function getTalentDetail(id) {
  return request({
    url: '/user/admin/enterprise/job/queryJobDetail/' + id,
    method: 'GET',
  })
}

// 查询人才库表单
export function getTalentDetailForm(id) {
  return request({
    url: '/user/admin/enterprise/job/queryJobDetailForm/' + id,
    method: 'GET',
  })
}

// 更新人才标签
export function updateTalentTag(data) {
  return request({
    url: '/user/admin/enterprise/job/updateJobTag',
    method: 'POST',
    data,
  })
}
